import { debounce } from '../lib/utils'

/**
 * PredictiveSearch is a custom HTMLElement that provides search-as-you-type functionality.
 * It listens for input events on the element, performs a search based on the entered value,
 * and updates the display with the fetched results.
 */
class PredictiveSearch extends window.HTMLElement {
  constructor() {
    super()
    this.form = this.querySelector('form')
    this.resultsGrid = this.querySelector('.results-grid')
  }

  /**
   * Handle the input change event and fetch the search results.
   * @param {Event} event - The input event object.
   */
  onChange(event) {
    document.dispatchEvent(new CustomEvent('theme:loading:cancel'), {
      bubbles: true,
    })

    document.dispatchEvent(new CustomEvent('theme:loading:start'), {
      bubbles: true,
    })

    const searchUrl = `${this.form.getAttribute('action')}?q=${
      event.target.value
    }`
    const encodedSearchUrl = encodeURI(searchUrl)

    fetch(encodedSearchUrl)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')

        const newResultsGrid = doc.querySelector('.results-grid')
        if (this.resultsGrid && newResultsGrid) {
          this.resultsGrid.replaceWith(newResultsGrid)
          this.resultsGrid = newResultsGrid // Update the reference
        } else {
          console.error(
            'Predictive search results not found in the fetched content.'
          )
        }
        document.dispatchEvent(new CustomEvent('theme:loading:end'), {
          bubbles: true,
        })
      })
  }

  connectedCallback() {
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event)
    }, 250)

    this.addEventListener('input', this.debouncedOnChange)
  }
}

// Register the custom element 'predictive-search'
window.customElements.define('predictive-search', PredictiveSearch)
